import { WaitlistForm } from "@/components/shared/WaitlistForm";
import { FloatingAccents } from "@/components/decorative";

export const WaitlistFormSection = () => {
  return (
    <section 
      id="waitlist-form" 
      className="relative min-h-screen flex items-center justify-center py-12 md:py-16 px-4 bg-background overflow-hidden"
    >
      <FloatingAccents position="both" />
      
      <div className="container mx-auto max-w-4xl relative z-10 w-full">
        <WaitlistForm />
      </div>
    </section>
  );
};
